import * as React from "react";
import { BaseBlock, BaseBlockOptions, DeviceDetect, broadcastBlockLoad, internalMessageBus } from "sb-resp-lib";

import { BaseDict } from "./dict";
import { SuperBanner } from "./SuperBanner";
import { SuperBannerData } from "./data";
import { DataParser } from "../../parser/DataParser";
import { DataFacade } from "../../data/DataFacade";
import { SuperBannerConfiguration, getEventIdsFromConfiguration } from "../../data";

/*
    This structure allows us to use mocks during dev
    but not to include them when we do build:release
*/
import { SportDataGateWayRetriever } from "../../data";
import { oddsFormatter } from "./helpers";
import { DeviceDetectHelper } from "../../parser";

let SportDataGateWayRetrieverMock;
let UserInfoMock;
let CurrentOddStyleMock;
let NavHandlerMock;
let BetSlipUtilMock;
let TimeControlMock;
let deviceDetectMock;
let uiPreferencesMock;
let clientIncludeInManagerMockInstance;

if (process.env.NODE_ENV === "development") {
    let _libMocks = require("sb-resp-lib/lib/mocks");
    let _localMocks = require("../../mocks");

    SportDataGateWayRetrieverMock = _localMocks.SportDataGateWayRetrieverMock;
    UserInfoMock = _libMocks.UserInfoMock;
    CurrentOddStyleMock = _localMocks.CurrentOddStyleCodeMock;
    NavHandlerMock = _libMocks.NavHandlerMock;
    BetSlipUtilMock = _libMocks.BetSlipUtilMock;
    TimeControlMock = _libMocks.TimeControlMock;
    uiPreferencesMock = require("../../mocks/UIPreferencesMock/UIPreferencesMock");
    deviceDetectMock = new _localMocks.DeviceDetectMock();
    clientIncludeInManagerMockInstance = _localMocks.ClientIncludeInManagerMockInstance;

    window["_cmsResponseTestCasesMock"] = _localMocks.CMSResponseTestCasesMock;
}

export class SuperBannerRoot extends BaseBlock {
    dataProvider!: SuperBannerData;
    options!: BaseBlockOptions;
    dataFacade!: DataFacade;

    // constructor sets defaults
    constructor(
        domId: string,
        options: BaseBlockOptions = {
            dict: BaseDict,
            cms: {},
            navHandler: {},
            dataProvider: {},
            betSlipUtil: {},
            gameStatus: {},
            timeControl: {},
            userInfo: {},
            panelId: ""
        }
    ) {
        super(domId, options);

        if (process.env.NODE_ENV === "development") {
            let cmsConfig = new SuperBannerConfiguration(options.cms,clientIncludeInManagerMockInstance);
            let eventIdsMock: number[] = getEventIdsFromConfiguration(options.cms);
            const htmlEl = document.documentElement;
            if (htmlEl) {
                htmlEl.classList.contains("IsDesktop") ? deviceDetectMock.setToDesktop() : deviceDetectMock.setToMobile();
            }
            this.dataFacade = new DataFacade({
                eventsIds: eventIdsMock,
                sportDataGatewayRetriever: new SportDataGateWayRetrieverMock(
                    "en"
                ),
                currentOddStyleIndex: CurrentOddStyleMock,
                userInfo: UserInfoMock,
                cms: cmsConfig,
                blockUniqueId: domId, utils: {
                    betSlipUtil: new BetSlipUtilMock(),
                    deviceDetect: new DeviceDetectHelper(deviceDetectMock),
                    navHandler: new NavHandlerMock(),
                    timeControl: new TimeControlMock(new Date())
                },
                currentSelectedSportId: 0,
                messageBus: internalMessageBus,
                dateFormat: uiPreferencesMock.dateFormat,
                timeFormat: uiPreferencesMock.timeFormat
            });

            let dataParser: DataParser = new DataParser(this.dataFacade);
            this.dataProvider = new SuperBannerData(dataParser, oddsFormatter,clientIncludeInManagerMockInstance);
        }

        if (process.env.NODE_ENV === "production"/* && typeof options.dataProvider !== "undefined"*/) {
            let cmsConfig = new SuperBannerConfiguration(options.cms,options.dataProvider.clientIncludeInManager);
            let eventsIds: number[] = getEventIdsFromConfiguration(options.cms);

            this.dataFacade = new DataFacade({
                sportDataGatewayRetriever: new SportDataGateWayRetriever(
                    options.dataProvider.languageCode, "sports_data_retriever_" + domId),
                eventsIds,
                currentOddStyleIndex: options.dataProvider.oddStyleCode,
                cms: cmsConfig,
                userInfo: options.userInfo,
                blockUniqueId: domId,
                currentSelectedSportId: 0,
                utils: {
                    betSlipUtil: options.betSlipUtil,
                    deviceDetect: new DeviceDetectHelper(DeviceDetect.getInstance()),
                    navHandler: options.navHandler,
                    timeControl: options.timeControl
                },
                messageBus: options.dataProvider.messageBus,
                dateFormat: options.dataProvider.dateFormat,
                timeFormat: options.dataProvider.timeFormat
            });

            let highlightsDataParser = new DataParser(this.dataFacade);//, this.options.cms, DeviceDetect.getInstance()
            this.dataProvider = new SuperBannerData(highlightsDataParser, oddsFormatter, options.dataProvider.clientIncludeInManager);
        }

        window["dataProvider"] = this.dataProvider;

        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = { ...BaseDict, ...(options.dict || {}) };
    }

    setParams(branchId) {
        const parsedId = parseInt(branchId);
        const id = isNaN(parsedId) ? 0 : parsedId;
        this.dataFacade.setCurrentSelectedSportId(id);
    }

    activate() {
        this.dataFacade.activate();
        this.dataProvider.updateClientIncludeData();
        return super.activate(
            // hardcoded rtl for testing purposes
            <SuperBanner dataProvider={this.dataProvider} dict={this.options.dict}
                cms={(new SuperBannerConfiguration(this.options.cms,this.dataProvider.clientIncludeInManager) || {})} />
        );
    }

    deactivate() {
        this.dataFacade.deactivate();
        return super.deactivate();
    }
}

window["SuperBanner"] = SuperBannerRoot;
broadcastBlockLoad("SuperBanner");